import SubView from "../SubView";
import {ColorInput} from "@mantine/core";
import {useContext, useEffect, useState} from "react";
import QRCodeStyleViewContext from "../../QRCodeStyleViewContext";
import HorizontalListView from "../../_utils/horizontal-list-view/HorizontalListView";
import HorizontalListViewItem from "../../_utils/horizontal-list-view/item/HorizontalListViewItem";
import DotsStyle from "../../../../../../../api/qr-code/style/DotsStyle";

function DotsView() {
    const [colorValue, setColorValue] = useState<string | null>();

    /**
     * payload, setPayload from context.
     * @author Kacper Faber
     * @since 0.1.9
     */
    const {payload, setPayload} = useContext(QRCodeStyleViewContext);

    /**
     * On color picker value is changed
     * @author Kacper Faber
     * @since 0.1.9
     */
    const onDotsColorChange=  (color: string | null) => {
        if (!payload) {
            return;
        }

        setColorValue(color);
        setPayload({...payload, dotsColor: color});
    };

    /**
     *
     * @author Kacper Faber
     * @since 0.1.9
     */
    const reload = () => {
        setColorValue(payload?.dotsColor);
    };

    const onTypeClick = (dotsStyle: DotsStyle) => {
        if (!payload){
            return;
        }
        setPayload({...payload, dotsStyle});
    }

    useEffect(reload, [payload?.dotsColor]);

    return (
        <SubView viewBack="index">
            <HorizontalListView label="Styl narożnika">
                <HorizontalListViewItem
                    children={<div style={{borderRadius: '15px', width: '10px', height: '10px', background: 'black'}}/>}
                    onClick={() => onTypeClick('square')}
                    active={payload?.dotsStyle == 'square'}
                />

                <HorizontalListViewItem
                    children={<div style={{borderRadius: '15px', width: '10px', height: '10px', background: 'black'}}/>}
                    onClick={() => onTypeClick('dots')}
                    active={payload?.dotsStyle == 'dots'}
                />

                <HorizontalListViewItem
                    children={<div style={{borderRadius: '15px', width: '10px', height: '10px', background: 'black'}}/>}
                    onClick={() => onTypeClick('extra_rounded')}
                    active={payload?.dotsStyle == 'extra_rounded'}
                />

                <HorizontalListViewItem
                    children={<div style={{borderRadius: '15px', width: '10px', height: '10px', background: 'black'}}/>}
                    onClick={() => onTypeClick('classy')}
                    active={payload?.dotsStyle == 'classy'}
                />

                <HorizontalListViewItem
                    children={<div style={{borderRadius: '15px', width: '10px', height: '10px', background: 'black'}}/>}
                    onClick={() => onTypeClick('classy_rounded')}
                    active={payload?.dotsStyle == 'classy_rounded'}
                />
            </HorizontalListView>

            <ColorInput
                value={colorValue ?? ''}
                label="Kolor kropek"
                onChange={onDotsColorChange}
            />
        </SubView>
    );
}

export default DotsView;